import React from 'react';

const TermsAndConditions = () => {
  return (
    <div>
      <h1>Terms & Conditions</h1>
    </div>
  );
};

export default TermsAndConditions;
